import { useEffect, useMemo } from 'react';
import { Select } from '@dynamika-shared/ui/Select/Select';
import { Option } from '@utils/generateOptions';
import { useWorkflowsSlice } from '@restore/workflows/workflows.slice';
import './workflow.scss';
import { useInventoryFormHandler } from '@hooks/useInventoryFormHandler';

export const WorkflowsSelect = () => {
  const { onChange, watch } = useInventoryFormHandler();

  const [workflows, fetchWorkflows] = useWorkflowsSlice((state, actions) => [
    state.workflows,
    actions.fetchWorkflows,
  ]);

  const workflowType = watch('workflowType');
  const workflowName = watch('workflowName');

  const memoizedTypes: Option[] = useMemo(() => {
    const distinctTypes = new Set(
      workflows.map(workflow => workflow.type).filter(Boolean)
    );

    return [...distinctTypes]
      .sort((a, b) => a.localeCompare(b))
      .map(type => ({ label: type, value: type }));
  }, [workflows]);

  const memoizedWorkflows: Option[] = useMemo(() => {
    return workflows
      .filter(workflow => workflow.type === workflowType)
      .map(workflow => ({
        label: workflow.name,
        value: workflow.id,
      }));
  }, [workflows, workflowType]);

  useEffect(() => {
    fetchWorkflows(undefined);
  }, []);
  return (
    <>
      <Select
        data-testid={'workflowType'}
        value={workflowType}
        placeholder={'Workflow Type'}
        label={'Workflow Type'}
        options={memoizedTypes}
        disabled={!watch('runnable')}
        onChange={value => {
          onChange('workflowName', '');
          onChange('workflowType', value);
        }}
      />
      <Select
        data-testid={'workflowName'}
        value={workflowName}
        placeholder={'Workflow Name'}
        label={'Workflow Name'}
        options={memoizedWorkflows}
        disabled={!watch('runnable')}
        onChange={id =>
          onChange(
            'workflowName',
            memoizedWorkflows.find(w => w.value === id)?.label as string
          )
        }
      />
    </>
  );
};
